import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';

//Helpers
import { showMessage } from '../../../helpers/message';

//Context
import { useAuth } from '../../../context/auth';

//API
import fiscalizacaoInfracaoDividaAtiva_api from '../../../api/fiscalizacaoInfracaoDividaAtiva_api';
import infracoes_api from '../../../api/infracoes_api';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';

// Estilo da página de impressão
const pageStyle = `
@page { size: auto; margin: 0mm; } 
@media print { body { -webkit-print-color-adjust: exact; } }
@media print {
  @page { size:A4; margin:0; }
  .relatorio { width:100vw!important; display:flex; flex-direction:column; }
  .noPrint { display:none; }
  .break { page-break-before: always; }
}
`;


function FichaSolicitacaoInscricaoDividaAtiva() {
    const { session, logoSistema, setLoading, logoSecretaria, logoPrefeitura, dadosSecretaria } = useAuth();

    const ref = useRef(null);
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const hash = query.get('hash');

    const navigator = useNavigate()

    //Estado para pegar os dados da solicitação da inscrição ativa
    const [dadosSolicitacaoInscricaoDividaAtiva, setDadosSolicitacaoInscricaoDividaAtiva] = useState(null);

    const handlePrint = useReactToPrint({
        content: () => ref.current,
        documentTitle: `FichaSolicitacaoInscricaoDividaAtiva_${dadosSolicitacaoInscricaoDividaAtiva?.numeroInfracao}`,
        pageStyle: pageStyle
    });


    async function loadFichaSolicitacaoInscricaoDividaAtiva(fiscalizacaoInfracao_Id) {
        setLoading(true)
        try {
            const { data } = await fiscalizacaoInfracaoDividaAtiva_api.GetFichaSolicitacaoInscricaoDividaAtiva(fiscalizacaoInfracao_Id);
            console.log(data)
            setDadosSolicitacaoInscricaoDividaAtiva(data)
        } catch (ex) {
            showMessage("Error", ex?.message ?? "Error na operação", "error", null)
        } finally {
            setLoading(false)
        }
    }

    async function loadDadosFiscalizacaoInfracao(hash) {
        setLoading(true);
        try {
            const { data } = await infracoes_api.GetItemFiscalizacaoHash(hash);
            if (data)
                await loadFichaSolicitacaoInscricaoDividaAtiva(data.id)
            else
                showMessage("Error", "Error ao abrir Termo de Solicitação de Inscrição em Dívida Ativa", "error", navigator(-1))
        } catch (error) {
            setLoading(false)
            showMessage("Error", error?.message ?? "Erro na operação!", "error", null);
        }
    }

    useEffect(() => {
        if (hash)
            loadDadosFiscalizacaoInfracao(hash);
    }, [hash]);

    if (!dadosSolicitacaoInscricaoDividaAtiva) return null

    return (
        <div className="d-flex flex-column gap-3 p-3" ref={ref}>
            <div className='noPrint'>
                <Button color="danger" onClick={handlePrint} className="mb-3">
                    <FontAwesomeIcon icon={faFilePdf} /> Imprimir
                </Button>
            </div>

            <div className='bg-white shadowFicha mainContainerFicha p-4'>

                <div className="mt-4 w-100">
                    <div className="print m-2 d-flex align-items-center justify-content-between">
                        <p>Emitido por: {session.nome}</p>
                        <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm:ss")}</p>
                    </div>

                    <div className='d-flex justify-content-between align-items-center w-100'>
                        {logoSecretaria &&
                            <div>
                                {logoSecretaria && <img src={logoSecretaria} className='mt-3' width={140} alt="logo do sistema" />}
                            </div>
                        }
                        <div className='mt-5' style={{ textAlign: 'center' }}>
                            <h5><b>PREFEITURA DO MUNICÍPIO DE {String(dadosSecretaria?.prefeitura).toUpperCase()}</b></h5>
                            <h5><b>{String(dadosSecretaria?.descricao).toUpperCase()}</b></h5>
                        </div>
                        <div>
                            {logoPrefeitura && <img src={logoPrefeitura} width={210} alt="logo da prefeitura" />}
                        </div>
                    </div>

                    <div className='mt-3 header'>
                        <p><b>SP-REGULA/SAF/GCOF</b></p>
                        <p className='mb-2'><b>Sra. Gerente,</b></p>

                        <p className='mb-2'>
                            Trata o presente do Auto de Infração e Sanção {dadosSolicitacaoInscricaoDividaAtiva?.numeroInfracao ?? ""},  por descumprimento às Leis Municipais nº 13.478/02 e nº 14.803/08, onde foi gerada a cobrança pecuniária através da guia {`${dadosSolicitacaoInscricaoDividaAtiva?.anoExercicio ?? ""}${dadosSolicitacaoInscricaoDividaAtiva?.guiaNumero ?? ""}`} com vencimento em {`${dadosSolicitacaoInscricaoDividaAtiva?.guiaVencimento ?? ""}`}, e que se encontra com prazo de pagamento excedido, estando apto para integração no Cadastro Informativo Municipal - CADIN e posteriormente no Portal de Disponibilização de Créditos - PDCs, conforme instruções contidas no Processo SEI (9310.2024/0001747-3).
                        </p>

                        <p>
                            Dessa forma, em cumprimento às orientações constantes em doc (112681557), seguem os dados solicitados para a integração:
                        </p>

                        <ul>
                            <li><b>CNPJ/CPF:</b> {dadosSolicitacaoInscricaoDividaAtiva?.infrator?.documento ?? ""}</li>
                            <li><b>Data da notificação:</b> {dadosSolicitacaoInscricaoDividaAtiva?.dataNotificacao ?? ""}</li>
                            <li><b>Ano do exercício da multa:</b> {dadosSolicitacaoInscricaoDividaAtiva?.anoExercicio ?? ""}</li>
                            <li><b>Vencimento legal:</b> {dadosSolicitacaoInscricaoDividaAtiva?.guiaVencimento}</li>
                            <li><b>Valor principal original:</b> R$ {dadosSolicitacaoInscricaoDividaAtiva?.valorMulta ?? ""}</li>
                            <li><b>Local de infração:</b> {dadosSolicitacaoInscricaoDividaAtiva?.localInfracao ?? ""}</li>
                            <li><b>Endereço do Infrator:</b> {dadosSolicitacaoInscricaoDividaAtiva?.infrator?.endereco ?? ""}</li>
                        </ul>

                        <p className='my-2'>
                            Sendo o que nos compete informar, e de ordem desta Gerência de Saneamento Ambiental, encaminhamos o presente para prosseguimento junto à SAF/GCOF para as providências pertinentes.
                        </p>

                        <br />
                        <hr />

                        <div style={{ textAlign: 'center' }}>
                            {logoSistema && <img src={logoSistema} width={150} alt="Logo SP Regula" />}
                            <p style={{ marginTop: '10px' }}>
                                Documento gerado automaticamente do sistema FiscSP por: <b>{session.nome}</b>, em {moment().format("DD/MM/YYYY")} às {moment().format("HH:mm:ss")}.
                            </p>
                        </div>

                        <hr />
                    </div>
                </div>
            </div>

        </div>
    );
}

export default FichaSolicitacaoInscricaoDividaAtiva;
